import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import NeoInput from "../../../components/Common/NeoInput";
import NeoAlert from "../../../components/Common/NeoAlert";
import NeoButton from "../../../components/Common/NeoButton";
import NeoCard from "../../../components/Common/NeoCard";
import NeoBadge from "../../../components/Common/NeoBadge";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import usePlatformNotifications from "./hooks/usePlatformNotifications";
import { TEMPLATE_VARIABLES_HINT } from "./constants";

const PlatformNotifications = () => {
    const { templates, selected, selectedId, saving, successMessage, error, setSelectedId, saveTemplate, toggleActive } = usePlatformNotifications();

    const [formContent, setFormContent] = useState("");

    const activeContent = selected ? formContent || selected.content : "";

    const handleSelectTemplate = (t) => {
        setSelectedId(t.id);
        setFormContent(t.content || "");
    };

    const handleSave = async () => {
        if (!selected) return;
        await saveTemplate({ ...selected, content: activeContent });
    };

    return (
        <div className="pb-5">
            <div className="mb-4">
                <Breadcrumb title="Notificações" />
            </div>

            {successMessage && (
                <NeoAlert color="success" className="mb-4 shadow-sm border-0" animate={false}>{successMessage}</NeoAlert>
            )}
            {error && (
                <NeoAlert color="danger" className="mb-4 shadow-sm border-0" animate={false}>{error}</NeoAlert>
            )}

            <Row className="g-4">
                <Col lg={5}>
                    <NeoCard title="Modelos Disponíveis" headerIcon="mdi-email-open-outline" thinBorder bodyClassName="p-4" className="h-100">
                        <div className="d-flex flex-column gap-3">
                            {templates.map((t) => {
                                const isSelected = selectedId === t.id || selected?.id === t.id;
                                return (
                                    <div
                                        key={t.id}
                                        className="p-3 border rounded cursor-pointer"
                                        style={{
                                            backgroundColor: isSelected ? "var(--color-bg-canvas, #fef5ef)" : "#fff",
                                            borderColor: isSelected ? "var(--color-brand-primary)" : "rgba(72, 39, 18, 0.08)",
                                            boxShadow: isSelected ? "var(--shadow-premium-soft)" : "none",
                                        }}
                                        onClick={() => handleSelectTemplate(t)}
                                    >
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <h6 className="fw-bold text-dark m-0 fs-6">{t.name}</h6>
                                            <NeoBadge color={t.active ? "success" : "muted"}>
                                                {t.active ? "Ativo" : "Pausado"}
                                            </NeoBadge>
                                        </div>
                                        <span className="text-xs text-muted d-block">Canal: <strong>{t.channel}</strong> | Disparo: {t.trigger}</span>
                                    </div>
                                );
                            })}
                            {templates.length === 0 && (
                                <div className="text-center py-4 text-muted text-sm">Nenhum modelo cadastrado.</div>
                            )}
                        </div>
                    </NeoCard>
                </Col>

                <Col lg={7}>
                    <NeoCard
                        title="Editor de Mensagem"
                        subtitle={<span>Variáveis: <code className="fw-bold">{TEMPLATE_VARIABLES_HINT}</code></span>}
                        headerIcon="mdi-square-edit-outline"
                        headerActions={
                            selected && (
                                <NeoButton
                                    variant={selected.active ? "outline-danger" : "outline-success"}
                                    size="sm"
                                    onClick={() => toggleActive(selected.id)}
                                    loading={saving}
                                >
                                    {selected.active ? "Pausar Gatilho" : "Ativar Gatilho"}
                                </NeoButton>
                            )
                        }
                        thinBorder
                        bodyClassName="p-4"
                        className="h-100"
                    >
                        {selected ? (
                            <>
                                <div className="mb-4">
                                    <NeoInput
                                        label="Conteúdo do Disparo"
                                        type="textarea"
                                        rows={8}
                                        value={activeContent}
                                        onChange={(e) => setFormContent(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex justify-content-end gap-2">
                                    <NeoButton variant="primary" onClick={handleSave} loading={saving} loadingText="Salvando...">
                                        Salvar Modelo
                                    </NeoButton>
                                </div>
                            </>
                        ) : (
                            <div className="text-center py-5 text-muted">Selecione um modelo para editar.</div>
                        )}
                    </NeoCard>
                </Col>
            </Row>
        </div>
    );
};

export default PlatformNotifications;
